import { render, staticRenderFns } from "./SinginModal.vue?vue&type=template&id=07f9ab6e&scoped=true&"
import script from "./SinginModal.vue?vue&type=script&lang=js&"
export * from "./SinginModal.vue?vue&type=script&lang=js&"
import style0 from "./SinginModal.vue?vue&type=style&index=0&id=07f9ab6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f9ab6e",
  null
  
)

export default component.exports